import type { FluxErrorEntityErrorCodes } from '../types.js';

export const ServiceAccountErrorCodes = {
  ServiceAccountAlreadyExists: {
    code: 'service-account/already-exists',
    explanation:
      'Uma conta de serviço com esse nome já existe na sua conta. Escolha um nome exclusivo.',
    localizations: {},
    message: 'Nome da conta de serviço já em uso',
  },
  ServiceAccountInvalidToken: {
    code: 'service-account/invalid-token',
    explanation: 'O token fornecido é inválido. Verifique a assinatura e o formato do token.',
    localizations: {},
    message: 'Token de conta de serviço inválido',
  },
  ServiceAccountKeysNotFound: {
    code: 'service-account/keys-not-found',
    explanation: 'Não foi possível encontrar as chaves de assinatura necessárias para esta conta.',
    localizations: {},
    message: 'Chaves de assinatura da conta ausentes',
  },
  ServiceAccountLimitReached: {
    code: 'service-account/limit-reached',
    explanation: 'Sua organização atingiu o número máximo de contas de serviço permitidas.',
    localizations: {},
    message: 'Limite de contas de serviço atingido',
  },
  ServiceAccountNotFound: {
    code: 'service-account/not-found',
    explanation: 'A conta de serviço solicitada não pôde ser encontrada ou foi excluída.',
    localizations: {},
    message: 'Conta de serviço não encontrada',
  },
  ServiceAccountTokenExchangeFailed: {
    code: 'service-account/token-exchange-failed',
    explanation:
      'Não foi possível trocar o token de longa duração inicial. Isso pode ser devido a uma incompatibilidade de hash ou a um token inválido.',
    localizations: {},
    message: 'Falha na troca de token',
  },
} as const satisfies FluxErrorEntityErrorCodes<'service-account'>;
